import { CreateElement } from 'vue'
import { RouteConfig } from 'vue-router'
import { CreateRouterOptions } from '@/typings/common'
import { LK_MUN_MEH_FORM_HOST_VIEW_ROUTES as ROUTES } from './utils'

type Options = Required<CreateRouterOptions>
type PromiseVue = Promise<typeof import('*.vue')>

const createRoutes = (options: Options): RouteConfig[] => [
  {
    path: 'view/:munMehId/form/:formId',
    name: ROUTES.LAYOUT,
    meta: { authorized: true },
    async beforeEnter(to, from, next) {
      const { registerModule } = await import(
        /* webpackChunkName: "mun-meh-lk-form-host-view.store" */
        './store'
      )
      registerModule(options)
      next()
    },
    component: {
      name: 'ViewLKMunMehFormLayout',
      render: (h: CreateElement) => h('router-view'),
    },
    children: [
      {
        path: 'indicators/:levels(.*)',
        name: ROUTES.ANY_LEVEL,
        props: true,
        component: (): PromiseVue => import(
          /* webpackChunkName: "mun-meh-lk.form.host-view.level" */
          './LKMunMehHostViewView.vue'
        ),
      },
      {
        path: '/',
        name: ROUTES.FORM,
        props: true,
        component: (): PromiseVue => import(
          /* webpackChunkName: "mun-meh-lk.form.host-view.view" */
          './LKMunMehHostViewView.vue'
        ),
      },
    ],
  },
]

const createSubModule = (options: Options) => {
  const routes = createRoutes(options)
  return routes
}

export default createSubModule
